export enum FiSideListType {
    Translations = 1,
    Contacts = 2,
}
